import { AxiosResponse } from 'axios'
import { HttpService } from '@/services/common/HttpService'

const httpService: HttpService = new HttpService()

export type ValidationDomain = 'QUOTE' | 'TRIP' | 'STOP' | 'ADDRESS' | 'VEHICLE'

export interface ValidationResultItem {
  domain: ValidationDomain
  id?: number | null
  orderIndex?: number | null
  parentDomain?: ValidationDomain | null
  parentOrderIndex?: number | null
  isValid: boolean
  errors: string[]
  warnings: string[]
}

export interface ValidateForEstimateResponse {
  results: ValidationResultItem[]
}

export interface ValidateForEstimateRequest {
  quote: {
    companyId?: number
    trips: Array<{
      tripId?: number
      orderIndex: number
      stops: Array<{
        orderIndex: number
        active?: boolean
        address?: {
          lat?: number
          lng?: number
          timezone?: string
          country?: string
        }
        pickupDatetime?: string
        dropoffDatetime?: string
      }>
      vehicles?: Array<{ vehicleTypeId?: number }>
    }>
  }
}

/**
 * Pre-flight validation to check if trips can be estimated.
 * Call this before calling the tripEstimations endpoint.
 */
export const validateForEstimate = async (
  payload: ValidateForEstimateRequest
): Promise<AxiosResponse<ValidateForEstimateResponse>> => {
  const url = '/validations/for-estimate'
  return httpService.post(url, payload)
}

/**
 * Checks if validation results indicate all items are valid.
 * Returns true if results array is empty or all items have isValid: true.
 */
export function isValidationSuccessful(response: ValidateForEstimateResponse): boolean {
  if (!response.results || response.results.length === 0) {
    return true
  }
  return response.results.every(result => result.isValid)
}

/**
 * Extracts all error codes from validation results.
 */
export function getValidationErrors(response: ValidateForEstimateResponse): string[] {
  if (!response.results) {
    return []
  }
  return response.results.flatMap(result => result.errors)
}
